import React from 'react';
import { Link } from 'react-router-dom';

function Level(props) {
  const { level, onDelete, showDelete } = props;

  return (
    <div className="col s12 m6">
      <div className="card z-depth-0 project-summary">
        <div className="card-content grey-text text-darken-3">
          <span className="company-address">Level: {level.levelName}</span>
          <p className="company-address">minXp: {level.minXp}</p>
          <p className="company-address">maxXp: {level.maxXp}</p>
        </div>
        <div className="card-action">
          <Link to={'/level/' + level.id} key={'edit_' + level.id}>
            Edit
          </Link>
          {showDelete && (
            <Link to="#" onClick={() => onDelete(level.id, level.levelName)} key={'delete_' + level.id}>
              Delete
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default Level;
